var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHamburger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 15,
    viewBox: "0 0 21 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4918 6.10098H2.7436C1.22455 6.10098 0 4.87643 0 3.35737C0 1.85382 1.22455 0.61377 2.7436 0.61377H15.7641C18.3837 0.61377 20.4918 2.73735 20.4918 5.34145V6.10098Z",
    fill: "#294993"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 8.95312H17.7482C19.2672 8.95312 20.4918 10.1777 20.4918 11.6967C20.4918 13.2158 19.2672 14.4403 17.7482 14.4403H5.48721C2.44909 14.4403 0 11.9912 0 8.95312Z",
    fill: "#294993"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3027 11V11.6975C10.3027 13.2166 11.5273 14.4411 13.0463 14.4411C14.5654 14.4411 15.7899 13.2166 15.7899 11.6975V11H10.3027Z",
    fill: "#294993"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.4346 4.45663V3.7436C7.4346 2.22455 6.21005 1 4.69099 1C3.18744 1.0155 1.96289 2.24005 1.96289 3.7436V4.44113H7.4346V4.45663Z",
    fill: "#294993"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburger);
export default __webpack_public_path__ + "static/media/Hamburger.3c0fe1543f7fcbedaab6a661759e6bc2.svg";
export { ForwardRef as ReactComponent };